import{a as t}from"./chunk-EI7MMDWY.js";var a=t((o,r=1)=>(r===0&&(r=o,o=0),Math.floor(Math.random()*(r-o))+o),"random");export{a};
